export default __webpack_public_path__ + "static/media/observation.c5c2c772.webp";